module.exports = __webpack_public_path__ + "static/media/kasa_mobile.dae31d7a.webp";